
//包含n个mutation的type名称常量
export const Receive_ruleForm='set_ruleForm'
export const Receive_valueArr= "set_value"


// WEBPACK FOOTER //
// ./src/store/mutation-type.js